import { render, staticRenderFns } from "./partybuilding.vue?vue&type=template&id=4518e632&scoped=true&lang=pug&"
import script from "./partybuilding.vue?vue&type=script&lang=js&"
export * from "./partybuilding.vue?vue&type=script&lang=js&"
import style0 from "./partybuilding.vue?vue&type=style&index=0&id=4518e632&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518e632",
  null
  
)

export default component.exports